var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgItIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.506 56.135H25.085a3.464 3.464 0 0 0-3.464 3.464V76.88a3.463 3.463 0 0 0 3.464 3.464h33.42a3.464 3.464 0 0 0 3.465-3.464V59.6a3.464 3.464 0 0 0-3.464-3.464zM41.8 70.846a2.371 2.371 0 1 1 2.193-1.462 2.365 2.365 0 0 1-2.193 1.462z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.518 79.724v2.197a2.769 2.769 0 0 0 2.768 2.769h40.398a2.769 2.769 0 0 0 2.769-2.769v-2.197H18.518z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.384 46.03c-2.21-1.583-3.588-3.799-3.588-6.263 0-4.78 5.19-8.69 11.583-8.69 6.394 0 11.59 3.879 11.59 8.69 0 4.81-5.19 8.69-11.59 8.69-1.205 0-2.405-.144-3.576-.428a8.827 8.827 0 0 1-2.538 1.974 9.204 9.204 0 0 1-2.893.93c.524-.85.87-1.798 1.018-2.786.101-.702.1-1.416-.006-2.117z",
    stroke: "#384E85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.502 51.38a14.63 14.63 0 0 0 5.674 1.111 14.845 14.845 0 0 0 3.575-.428 8.808 8.808 0 0 0 2.539 1.974 9.024 9.024 0 0 0 2.899.931 7.399 7.399 0 0 1-1.024-2.787 7.26 7.26 0 0 1 0-2.092c2.21-1.577 3.587-3.799 3.587-6.257 0-2.731-1.688-5.171-4.345-6.754",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 85h60.212M58.817 55.825H24.154a3.464 3.464 0 0 0-3.464 3.464v17.902a3.464 3.464 0 0 0 3.464 3.464h34.663a3.464 3.464 0 0 0 3.463-3.464V59.29a3.464 3.464 0 0 0-3.463-3.464z",
    stroke: "#384E85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.31 80.034h-3.103v1.862A3.104 3.104 0 0 0 21.311 85h40.348a3.103 3.103 0 0 0 3.104-3.104v-1.862h-3.104",
    stroke: "#384E85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.897 38.58a1.353 1.353 0 1 0 0 2.706 1.353 1.353 0 0 0 0-2.706zM64.633 38.58a1.353 1.353 0 1 0 0 2.706 1.353 1.353 0 0 0 0-2.706zM69.37 38.58a1.353 1.353 0 1 0 0 2.707 1.353 1.353 0 0 0 0-2.707z",
    fill: "#118936"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.037 37.823h1.72c2.005 0 3.246-1.241 3.246-2.607v-4.22",
    stroke: "#384E85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.914 36.272h-2.098c-.792 0-1.434.642-1.434 1.433v.236c0 .792.642 1.434 1.434 1.434h2.098c.792 0 1.434-.642 1.434-1.434v-.236c0-.791-.642-1.433-1.434-1.433z",
    fill: "#384E85"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m25.346 29.443 2.819-1.241s.422-6.568 4.866-8.07c2.626-.894 10.354 1.242 12.16 1.465 1.035.119 2.08.085 3.104-.1v7.326h1.863c1.545-2.576 1.632-6.344.726-8.803l1.564-5.127c-1.241-.192-2.483-.13-3.761-1.074-2.694-1.943-6.208-4.01-10.007-3.805-3.476.186-6.282 3.172-6.282 3.172s-4.525 1.142-6.43 4.463c-1.906 3.321-.622 11.794-.622 11.794z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.518 28.513h-.074a1.794 1.794 0 0 0-1.782 1.992l.056.466a2.184 2.184 0 0 0 2.173 1.943M15.104 76.93V62.341c0-7.784 4.053-11.471 11.614-14.215 3.103-1.124 5.766-2.26 5.766-5.649v-.931M43.037 41.547v.826c0 3.414 2.688 4.556 5.81 5.692.87.316 1.689.62 2.483.987M38.071 34.098h.503a1.36 1.36 0 0 0 1.36-1.36v-2.88c0-1.744.664-2.65 1.527-2.681h2.594",
    stroke: "#384E85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.019 41.318a9.565 9.565 0 0 1-5.19 1.782c-4.345 0-9.69-4.73-9.69-10.733V27.27M48.003 22.305v6.207M34.967 27.27h-2.483M25.036 25.409c-1.192-5.953 1.781-10.429 6.828-11.869M51.114 26.501c.794-2.557.415-4.513-.249-6.828",
    stroke: "#384E85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.14 27.27s.62-6.43 5.667-7.157c5.047-.726 16.81 7.126 18.622-5.133M52.038 14.98c-3.967 0-5.053-3.247-10.46-4.346-7.107-1.421-9.373 2.887-9.373 2.887M45.657 46.824c0 2.564-3.439 4.65-7.672 4.65-4.234 0-7.672-2.086-7.672-4.65",
    stroke: "#384E85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.726 31.306a.931.931 0 1 0 0-1.863.931.931 0 0 0 0 1.863zM43.038 31.306a.931.931 0 1 0 0-1.863.931.931 0 0 0 0 1.863z",
    fill: "#384E85"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItIcon);
export default __webpack_public_path__ + "static/media/IT_ICON.95bb0ac21d92234a209cb9aeb8a547ff.svg";
export { ForwardRef as ReactComponent };